export class HhsgSharedClientContact {
	id: number;
	clientId: number;
	name: string;
	notes: string;
	roleOrTitle: string;
	phone: string;
	extension: string;
	clientContactEmailModels: HhsgSharedClientContactEmail[];
	clientContactApplicationModels: HhsgSharedClientContactApplication[];
	isEditing: boolean;
	isNew: boolean;
}

export class HhsgSharedClientContactEmail {
	id: number;
	clientContactId: number;
	email: string;
}

export class HhsgSharedClientContactApplication {
	id: number;
	applicationId: number;
	clientContactId: number;
}
